import { render, staticRenderFns } from "./BrandPanelColorEdit.vue?vue&type=template&id=092c1c34&"
import script from "./BrandPanelColorEdit.vue?vue&type=script&lang=ts&"
export * from "./BrandPanelColorEdit.vue?vue&type=script&lang=ts&"
import style0 from "./BrandPanelColorEdit.vue?vue&type=style&index=0&id=092c1c34&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports